import { render, staticRenderFns } from "./AfterInfo.vue?vue&type=template&id=5147473c"
import script from "./AfterInfo.vue?vue&type=script&lang=js"
export * from "./AfterInfo.vue?vue&type=script&lang=js"
import style0 from "./AfterInfo.vue?vue&type=style&index=0&id=5147473c&prod&scoepd=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports